type LogoProps = {
  size?: number
  className?: string
}

/** TransliFlow brand mark — a gradient badge with flowing text-stream lines. */
export default function Logo({ size = 32, className }: LogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="TransliFlow"
    >
      <defs>
        <linearGradient id="tf-bg" x1="0" y1="0" x2="512" y2="512" gradientUnits="userSpaceOnUse">
          <stop stopColor="#6366F1" />
          <stop offset="1" stopColor="#8B5CF6" />
        </linearGradient>
      </defs>
      <rect width="512" height="512" rx="116" fill="url(#tf-bg)" />
      <g stroke="#FFFFFF" strokeWidth="34" strokeLinecap="round" fill="none">
        <path d="M104 198 Q180 134 256 198 T408 198" opacity="0.95" />
        <path d="M104 314 Q180 250 256 314 T408 314" opacity="0.7" />
      </g>
      <circle cx="256" cy="256" r="20" fill="#FFFFFF" />
    </svg>
  )
}
